const $inject = [];

const lbTripOptionsHotelForm = {
  controller: 'lbTripOptionsHotelFormCtrl as vm',
  template: require('./lbTripOptionsHotelForm.html'),
  bindings: {
    searches: '=',
    optionsForm: '='
  }
};

lbTripOptionsHotelForm.$inject = $inject;

export default lbTripOptionsHotelForm;




// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsHotelForm.js